import { styled } from "styled-components";

import { colorsPalettes, fonts } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledPdfHeader = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
`;

export const StyledBenchmarkName = styled.div`
    color: ${colorsPalettes.carbon["500"]};
    font-family: ${fonts.$dmSansFontFamily};
    font-size: 1.12rem;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 4px;
`;

export const StyledInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const StyledInfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledIconWrapper = styled.div`
    width: 16px;
    height: 16px;
`;

export const StyledText = styled.span`
    display: block;
    color: ${colorsPalettes.carbon["250"]};
    font-size: 0.85rem;
    line-height: 16px;
`;
